import { createSlice } from '@reduxjs/toolkit';
import { lookupProviderByNameApi } from '../../../rtk-apis/hl7/lookupProviderByName';

const initialState = {
  status: '',
  result: null as any,
  msg: '',
  loading: false,
};

const lookupProviderByNameSlice = createSlice({
  name: 'lookupProviderByName',
  initialState,
  reducers: {
    clearState: state => {
      state.status = '';
      state.result = null;
      state.msg = '';
      state.loading = false;
    },
  },
  extraReducers: builder => {
    builder
      .addCase(lookupProviderByNameApi.pending, state => {
        state.loading = true;
      })
      .addCase(lookupProviderByNameApi.fulfilled, (state, action) => {
        state.loading = false;
        state.status = 'SUCCESS';
        state.result = action.payload;
        state.msg = action.payload?.msg || '';
      })
      .addCase(lookupProviderByNameApi.rejected, (state, action) => {
        state.loading = false;
        state.status = 'FAILED';
        state.msg = (action.payload as string) || 'Lookup failed';
      });
  },
});

export const { clearState: clearLookupProviderState } = lookupProviderByNameSlice.actions;
export default lookupProviderByNameSlice.reducer;
